
let ASSET_URL = "https://sstech-aws-s3.s3.amazonaws.com/";
let URL;

URL = 'https://api.gotosam.in/api/'
// URL = 'http://13.203.52.194:2024/api/'
// URL = 'http://localhost:2024/api/'

let apiPath = {

  baseURL: URL,
  assetURL: ASSET_URL,
  dashboard: "admin/dashboard",
  location: "admin/dashboard/location",

  // Auth API
  logout: "admin/auth/logout",
  login: "admin/auth/login",

  profile: "admin/auth/get-profile",
  updateProfile: "admin/auth/update-profile",
  changePassword: "admin/auth/change-password",
  updateAppSetting: "admin/auth/update-app-setting",

  forgotPassword: "admin/auth/forgot-password",
  verifyOTP: "admin/auth/verify-otp",
  resetPassword: "admin/auth/reset-password",

  // Brand APIs
  listBrand: "admin/brand/list",
  addEditBrand: "admin/brand/add-edit",
  editBrand: "admin/brand/edit",
  statusBrand: "admin/brand/status",
  verifyBrand: "admin/brand/verify",
  viewBrand: "admin/brand/view",
  viewSuggestBrand: "admin/brand/suggestion-list",
  generateNumber: "admin/brand/generate-number",

  // City APIs
  listCity: "admin/city/list",
  addEditCity: "admin/city/add-edit",
  statusCity: "admin/city/status",
  viewCity: "admin/city/view",
 
  // User APIs
  listUser: "admin/user/list",
  spListUser: "admin/user/sp-list",
  addEditUser: "admin/user/add-edit",
  statusUser: "admin/user/status",
  viewUser: "admin/user/view",
  importFile: "admin/user/import-file",

  // Service APIs
  listService: "admin/service/list",
  addEditService: "admin/service/add-edit",
  viewService: "admin/service/view",
  editService: "admin/service/edit",
  statusService: "admin/service/status",
  importService: "admin/service/import-file",

  // CMS APIs
  listCms: "admin/cms/list",
  addEditCms: "admin/cms/add-edit",
  statusCms: "admin/cms/status",
  viewCms: "admin/cms/view",

  // Tag APIs
  listTag: "admin/tag/list",
  addEditTag: "admin/tag/add-edit",
  statusTag: "admin/tag/status",

  // Referral APIs
  listReferral: "admin/referral/list",
  addEditReferral: "admin/referral/add-edit",
  statusReferral: "admin/referral/status",
  editReferral: "admin/referral/edit",
  viewReferral: "admin/referral/view",
  generateReferralCode: "admin/referral/generate-code",

  // Cluster APIs
  listCluster: "admin/cluster/list",
  addEditCluster: "admin/cluster/add-edit",
  statusCluster: "admin/cluster/status",
  viewCluster: "admin/cluster/view",
  
  listCategory: "admin/category/main/list",
  addEditCategory: "admin/category/main/add-edit",
  viewCategory: "admin/category/main/view",
  statusCategory: "admin/category/main/status",

  listSubCategory: "admin/category/sub/list",
  addEditSubCategory: "admin/category/sub/add-edit",
  viewSubCategory: "admin/category/sub/view",
  statusSubCategory: "admin/category/sub/status",

  // Common Routes 
  commonImageUpload: "common/image-upload",
  commonMultipleImageUpload: "common/multiple-image-upload",
  commonCategory: "common/category",
  commonTag: "common/tag",
  commonSubCategory: "common/sub-category",
  commonBrand: "common/brand",
  commonBrandSearch: "common/brand-search",
  commonBrandPopularity: "common/brand-popularity",
  commonCluster: "common/cluster",
  commonCity: "common/city",
  commonCms: "common/content",
};

export default apiPath;
